<script>
// remove template section and use base
import Log from 'loglevel';
import has from 'lodash/has';
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default Line.extend({
  mixins: [reactiveProp],
  props: [ 'options' ],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
})
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// LineGraph.vue?1a72d4f4